const styles = {
    root: {
        fontFamily: "HerbalifeFont",
        height: "100dvh",
    },
    heading: {
        color: 'var(--color-text-secondary)',
        textAlign: { xs: "center", md: 'left' },
        fontFamily: 'HerbalifeFont',
        fontSize: { xs: "16px", md: "44px" },
        fontStyle: 'normal',
        fontWeight: 700,
        lineHeight: 'normal',
        '--leading-trim': 'both',
        '--text-edge': 'cap',
        padding: '0 20px'
    },
    subHeading: {
        color: 'var(--color-text-secondary)',
        fontSize: { xs: "16px", md: '26px' },
        fontStyle: 'normal',
        fontWeight: 500,
        textAlign: { xs: "center", md: 'left' },
        paddingBottom: { xs: "8px", md: "40px" },
        lineHeight: "normal",
    },
    inputContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: { xs: "center", md: "center" },
        justifyContent: { xs: "center", md: "center" },
        width: "100%",
        // padding: { xs: "0px", md: "0 66px" }
    },
    infoBox: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        width: { xs: '159px', md: '300px' },
        // height: { xs: '96px', md: '85px' },
        flexShrink: 0,
        borderRadius: '8px',
        background: '#C6E2CF',
        padding: { xs: "10px", md: "20px" },
        fontSize: { xs: '11px', md: "14px" },
        gap: { xs: "5px", md: "25px" },
        flexDirection: { xs: "column", md: "column" },
        textAlign: "center",
    },
    inputContainer2: {
        display: "flex",
        flexDirection: "column",
        alignItems: { xs: "center", md: "flex-start" },
        justifyContent: { xs: "center", md: "flex-start" },
        width: "100%"
    },
    productContainer: {
        display: 'flex',
        height: { xs: "220px", md: '585px' },
        width: { xs: "170px", md: "400px" },
        padding: { xs: "2px", md: '20px' },
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: { xs: '6px', md: '10px' },
        alignSelf: 'stretch',
        borderRadius: { xs: '5px', md: '21px' },
        border: '1px solid var(--color-border-dark)',
    },
    addToCartButton: {
        padding: '3px 20px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '10px',
        border: "1px solid var(--color-border-dark)",
        color: 'var(--color-text-inverse)',
        textAlign: 'center',
        fontFamily: 'HerbalifeFont',
        background: "#FF6392",
        fontSize: { xs: "10px", md: '15px' },
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        letterSpacing: '0.8px',
        height: { xs: "22px", md: "50px" },
        width: "90%"
    },
    rangeBox: {
        display: "flex",
        width: { xs: "70px", md: "100px" },
        height: { xs: "70px", md: "100px" },
        flexDirection: "column",
        justifyContent: "center",
        padding: "2px",
        alignItems: "center",
        flexShrink: 0,
        borderRadius: "100px",
    }

}

// Common MUI component styles used across multiple pages
export const COMMON_MUI_STYLES = {
  textField: {
    "& .MuiInputBase-input": {
      color: "var(--color-text-primary)",
      textAlign: "left",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "0.3125rem",
      backgroundColor: "#fff",
      "& fieldset": {
        border: "1.5px solid var(--color-border)",
      },
      "&:hover fieldset": {
        border: "1.5px solid var(--color-border-hover)",
      },
      "&.Mui-focused fieldset": {
        border: "1.5px solid var(--color-info)",
      },
    },
    "& input::placeholder": {
      color: "var(--color-text-primary)",
      fontWeight: 500,
      opacity: 1,
      textAlign: "left",
    },
    "& .MuiInputAdornment-root": {
      "& .MuiIconButton-root": {
        color: "var(--color-text-primary)",
        "&:hover": {
          backgroundColor: "var(--color-surface-hover)",
        },
      },
    },
    // Ensure all inputs are left-aligned, including password fields
    "& input": {
      textAlign: "left !important",
    },
    // Handle password fields with InputAdornment
    "& .MuiInputBase-inputAdornedEnd": {
      paddingRight: "48px !important",
      textAlign: "left !important",
    },
  },
  button: {
    backgroundColor: "var(--color-primary)",
    color: "var(--color-text-inverse)",
    textTransform: "none",
    fontSize: "1rem",
    fontWeight: 500,
    borderRadius: "74px",
    "&:hover": {
      backgroundColor: "var(--color-primary-hover)",
    },
  },
  title1: {
    color: "var(--color-text-primary)",
    textAlign: "center",
    fontSize: "1.3rem",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "normal",
  },
  primaryCtaButton: {
    lineHeight: "normal",
    fontWeight: 700,
    borderRadius: "74px",
    backgroundColor: "var(--color-primary)",
    color: "var(--color-text-inverse)",
    textTransform: "none",
    width: {
      xs: "80%",
      sm: "80%",
      md: "auto",
    },
    fontSize: {
      xs: "1rem",
      sm: "1.2rem",
      md: "1.5rem",
    },
    padding: {
      xs: "12px 24px",
      sm: "14px 28px",
      md: "10px 32px",
    },
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "var(--color-primary-hover)",
    },
    "& > *:not(.loader-overlay)": {
      transition: "opacity 0.2s ease-in-out",
    },
  },
  primaryCtaButton1: {
    lineHeight: "normal",
    fontWeight: 500,
    borderRadius: "74px",
    backgroundColor: "var(--color-primary)",
    color: "var(--color-text-inverse)",
    textTransform: "none",
    width: {
      xs: "100%",
      sm: "80%",
      md: "100%",
    },
    fontSize: {
      xs: "1rem",
      sm: "1.2rem",
      md: "1.2rem",
    },
    padding: {
      xs: "12px 24px",
      sm: "14px 28px",
      md: "10px 32px",
    },
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "var(--color-primary-hover)",
    },
    "& > *:not(.loader-overlay)": {
      transition: "opacity 0.2s ease-in-out",
    },
  },
    primaryCtaButton2: {
    lineHeight: "normal",
    fontWeight: 500,
    borderRadius: "74px",
    backgroundColor: "var(--color-primary)",
    color: "var(--color-text-inverse)",
    textTransform: "none",
    width: {
      xs: "80%",
      sm: "80%",
      md: "auto",
    },
    fontSize: {
      xs: "1rem",
      sm: "1.2rem",
      md: "1.2rem",
    },
    padding: {
      xs: "12px 24px",
      sm: "14px 28px",
      md: "10px 32px",
    },
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    transition: "all 0.2s ease-in-out",
    "&:hover": {
      backgroundColor: "var(--color-primary-hover)",
    },
    "& > *:not(.loader-overlay)": {
      transition: "opacity 0.2s ease-in-out",
    },
  },
} as const;

export default styles;

